import { ArkActionTypes } from '../../../../../actions/dashboards/Ark'
import { Types as ProductsTypes } from '../../../../../actions/products'
import { Metrics } from '../../../../../constants/Dashboards'
import { Product } from '../../../../products'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { AsyncReducerTransformAction } from '../../asyncStatReducer/types'
import { InteractionsProducts } from '../../types'

function getMetricFromActionType(actionType: string | undefined): Metrics | null {
    switch (actionType) {
        case ArkActionTypes.DASHBOARD_ARK_DWELL_TIME_SKU.request:
        case ArkActionTypes.DASHBOARD_ARK_DWELL_TIME_SKU.failure:
        case ArkActionTypes.DASHBOARD_ARK_DWELL_TIME_SKU.success:
            return Metrics.ARK_DWELL_TIME_SKU
        case ArkActionTypes.DASHBOARD_ARK_NO_INTERACTIONS_SKU.request:
        case ArkActionTypes.DASHBOARD_ARK_NO_INTERACTIONS_SKU.failure:
        case ArkActionTypes.DASHBOARD_ARK_NO_INTERACTIONS_SKU.success:
            return Metrics.ARK_NO_INTERACTIONS_SKU
        case ArkActionTypes.DASHBOARD_ARK_SESSIONS_SKU.request:
        case ArkActionTypes.DASHBOARD_ARK_SESSIONS_SKU.failure:
        case ArkActionTypes.DASHBOARD_ARK_SESSIONS_SKU.success:
            return Metrics.ARK_SESSIONS_SKU
        default:
            return null
    }
}

/**
 * Large Vision Interactions Per Product reducer
 */
const arkProductDetails = buildAsyncStatReducer({
    key: (action: AsyncReducerTransformAction) => {
        return getMetricFromActionType(action.meta?.secondaryType)
    },
    types: {
        request: ProductsTypes.DCG_PRODUCT_INFORMATION.request,
        success: ProductsTypes.DCG_PRODUCT_INFORMATION.success,
        failure: ProductsTypes.DCG_PRODUCT_INFORMATION.failure,
    },
    transform: (state: any, { payload, meta }): InteractionsProducts | undefined => {
        const metric: Metrics | null = getMetricFromActionType(meta?.secondaryType)

        if (!metric) {
            return
        }

        const products: Product[] = payload?.data?.getProducts || []
        const { stats } = state
        const data: InteractionsProducts = stats[metric]

        if (!data) {
            return
        }

        const links: (string | null)[] = []
        const oldDataLabels: string[] = data.labels
        const newDataLabels: string[] = oldDataLabels.map((sku: string): string => {
            const productData: Product | undefined = products.find((product: Product): boolean => {
                return product?.sku === sku
            })

            if (productData) {
                const title: string = productData.title.en_gb
                const link = productData?.link
                links.push(link || null)

                return `${sku} ${title}`
            }

            return sku
        })

        return {
            ...data,
            labels: newDataLabels,
            links,
        }
    },
})

export default arkProductDetails
